import { NgModule } from '@angular/core';

import { TokenbeheerResource } from './tokenbeheer.resource';

/**
 * @ngdoc module
 * @name TokenbeheerModule
 * @description interface to apic-tokenbeheer
 **/
@NgModule({
    providers: [TokenbeheerResource]
})
export class TokenbeheerModule {}
